export default {
  default: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260908053423/layouts/default.vue").then(m => m.default || m),
  empty: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260908053423/layouts/empty.vue").then(m => m.default || m)
}